import { useState } from "react";
import "./App.css";

const NUM_DISCS = 5;
const INTNUM = [];
for (var i = NUM_DISCS; i > 0; i--) {
  INTNUM.push(i);
}
INTNUM.reverse();

function App() {
  const [towers, setTowers] = useState([INTNUM, [], []]);
  const [selectedTowerIndex, setSelectedTowerIndex] = useState();

  function handleClickedTower(clickedTowerIndex) {
    if (selectedTowerIndex !== undefined && selectedTowerIndex!== clickedTowerIndex ) {
      const selectedTower = towers[selectedTowerIndex];
      const clickedTower = towers[clickedTowerIndex];
      if (selectedTower[0] > clickedTower[0] ?? 1000) {
        setSelectedTowerIndex(undefined);
        return;
      }
      const newTowers = [...towers];

      const poppedDisc = newTowers[selectedTowerIndex].shift();
      newTowers[clickedTowerIndex].unshift(poppedDisc);
      setTowers(newTowers);
      setSelectedTowerIndex(undefined);
      if (towers[2].length >= NUM_DISCS) {
        alert("YOU WIN");
      }
    } else {
      setSelectedTowerIndex(clickedTowerIndex);
    }
  }
  return (
    <div className="App">
      <div className="heading">TOWER OF HANOI</div>
      <div className="towers">
        {towers.map((discs, towerIndex) => (
          <div
            onClick={() => handleClickedTower(towerIndex)}
            className={"tower"}
            key={towerIndex}
          >
            <div className="line"></div>
            <div className="discs">
              {discs.map((discNumber) => (
                <div
                  key={discNumber}
                  className="disc"
                  style={{
                    width: `${discNumber * 30 + 10}px`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        ))}

        <p>
          {" "}
          RULES:
          <br />
          <br />
          1. Only one disk may be moved at a time.
          <br />
          2.Each move consists of taking the upper disk from one of the stacks
          <br /> and placing it on top of another stack or on an empty rod.
          <br />
          3.No disk may be placed on top of a disk that is smaller than it.
          <br />
        </p>
      </div>
    </div>
  );
}

export default App;
